import { exists } from '@/api'

export interface BatchCollectionMgmtBibColBulkRemovalConditionListItem {
  removalDateFrom: string
  removalDateTo: string
  holdingBranch: string
  removeReason: string

  rdoCollectionType: string
  collectionTypeList: string
  rdoHandlingType: string
  handlingTypeList: string
  rdoShelfType: string
  shelfTypeList: string
  rdoBibColRemovalType: string
  rdoDatabaseUpdate: string
  memo: string
  batchType: string
}

export function BatchCollectionMgmtBibColBulkRemovalConditionListItemFromJSON(
  json: any
): BatchCollectionMgmtBibColBulkRemovalConditionListItem {
  const resp = JSON.parse(json)

  return {
    removalDateFrom: exists(resp, 'removal_date_from')
      ? resp.removal_date_from
      : '',
    removalDateTo: exists(resp, 'removal_date_to') ? resp.removal_date_to : '',
    holdingBranch: exists(resp, 'holding_branch') ? resp.holding_branch : '',
    removeReason: exists(resp, 'remove_reason') ? resp.remove_reason : '',

    rdoCollectionType: exists(resp, 'rdo_collection_type')
      ? resp.rdo_collection_type
      : '1',
    collectionTypeList: exists(resp, 'collection_type_list')
      ? resp.collection_type_list
      : '',
    rdoHandlingType: exists(resp, 'rdo_handling_type')
      ? resp.rdo_handling_type
      : '1',
    handlingTypeList: exists(resp, 'handling_type_list')
      ? resp.handling_type_list
      : '',
    rdoShelfType: exists(resp, 'rdo_shelf_type') ? resp.rdo_shelf_type : '1',
    shelfTypeList: exists(resp, 'shelf_type_list') ? resp.shelf_type_list : '',

    rdoBibColRemovalType: exists(resp, 'rdo_bib_col_removal_type')
      ? resp.rdo_bib_col_removal_type
      : '1',
    rdoDatabaseUpdate: exists(resp, 'rdo_database_update')
      ? resp.rdo_database_update
      : '2',
    memo: exists(resp, 'memo') ? resp.memo : '',
    batchType: resp.batch_type
  }
}
